import useSWR from "swr";
import { simpleFetcher } from "../fetcher";
import { type WorkflowStepType } from "../types";

const url = "/api/v2/workflows/my-todos";

export const TodoTypes = {
  activeStep: "activeStep",
  stepToMove: "stepToMove",
  documentToRead: "documentToRead",
  invitedToQuiz: "invitedToQuiz",
} as const;

export type TodoItem = ActiveStep | StepToMove | DocumentToRead | InvitedToQuiz;

interface OwnerSummary {
  userId: number;
  firstName: string;
  lastName?: string;
  imageUrl?: string;
}

interface ActiveStep {
  id: number;
  todoType: "activeStep";
  documentId: number;
  title: string;
  dueDate: string | null;
  documentVersionReviewTo: string | null;
  stepType: WorkflowStepType;
  owner: OwnerSummary;
}

export const MoveTypes = {
  forwards: "forwards",
  backwards: "backwards",
  publish: "publish",
} as const;

type MoveType = (typeof MoveTypes)[keyof typeof MoveTypes];

interface StepToMove {
  id: number;
  todoType: "stepToMove";
  documentId: number;
  title: string;
  moveType: MoveType;
  dueDate: string | null;
  documentVersionReviewTo: string | null;
  rejector?: {
    userId: number;
    firstName: string;
    lastName: string;
  };
  owner: OwnerSummary;
}

interface DocumentToRead {
  id: number;
  todoType: "documentToRead";
  documentId: number;
  documentVersionId: number;
  title: string;
  adoptedAt: string | null;
  publishedAt: string | null;
  owner: OwnerSummary;
}

interface InvitedToQuiz {
  id: number;
  todoType: "invitedToQuiz";
  quizId: number;
  documentId: number;
  documentVersionId: number;
  title: string;
  createdAt: string;
  owner: OwnerSummary;
}

export function useMyTodos() {
  return useSWR<TodoItem[], Error>(url, simpleFetcher);
}
